// Utils
import cn from '../../../utils/cn';

// Style
import styles from './DashboardTab.module.css';

/**
 * Tab button for dashboard navigation.
 * @param {object} params
 * @param {React.ReactNode} params.children - Tab label
 * @param {string} [params.className] - Additional CSS classes
 * @param {() => void} params.onClick - Click handler
 * @param {boolean} [params.isActive=false] - Whether this tab is currently active
 * @returns {JSX.Element}
 */
function DashboardTab({
  children,
  className,
  onClick,
  isActive = false,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn([styles['dashboard-tab'], isActive && styles['dashboard-tab-active'], className])}
    >
      {children}
    </button>
  );
}

export default DashboardTab;
